import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="container mx-auto py-10 px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="/ctrlp_white_nobg.png" 
                alt="CTRL+P Logo" 
                className="h-10 w-auto" 
              />
            </div>
            <p className="text-gray-300 leading-relaxed">Your one-stop solution for all printing needs. Fast, reliable, and convenient.</p>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/" className="text-gray-300 hover:text-white transition-colors duration-300">Home</a></li>
              <li><a href="/#about-us" className="text-gray-300 hover:text-white transition-colors duration-300">About Us</a></li>
              <li><a href="/my-account?tab=support" className="text-gray-300 hover:text-white transition-colors duration-300">Support</a></li>
              <li><a href="/sitemap" className="text-gray-300 hover:text-white transition-colors duration-300">Sitemap</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li><a href="/get-print" className="text-gray-300 hover:text-white transition-colors duration-300">Upload & Print</a></li>
              {/* <li><a href="/print-bazaar" className="text-gray-300 hover:text-white transition-colors">PrintBazaar</a></li> */}
              <li><a href="/ads" className="text-gray-300 hover:text-white transition-colors duration-300">Become an Advertiser</a></li>
              <li><a href="/shop-registration" className="text-gray-300 hover:text-white transition-colors duration-300">Shop Registration</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center text-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
                info@ctrlp.co.in
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
          <p className="text-sm">&copy; {new Date().getFullYear()} CTRL+P. All rights reserved.</p>
          <div className="mt-4 flex justify-center space-x-4">
            <a href="/privacy-policy" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Privacy Policy</a>
            <span className="mx-2">|</span>
            <a href="/terms-and-conditions" className="text-gray-300 hover:text-white transition-colors duration-300 text-sm">Terms & Conditions</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
